import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Heart } from "lucide-react";
import { SOCIAL, LOGO_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 bg-[#3F2A56] text-[#F4E8C8]"
    >
      <div className="absolute -top-6 left-0 right-0 h-12 bg-[#3F2A56]"
        style={{
          clipPath:
            "polygon(0 50%, 4% 30%, 8% 60%, 12% 25%, 16% 55%, 20% 30%, 24% 60%, 28% 25%, 32% 55%, 36% 30%, 40% 60%, 44% 25%, 48% 55%, 52% 30%, 56% 60%, 60% 25%, 64% 55%, 68% 30%, 72% 60%, 76% 25%, 80% 55%, 84% 30%, 88% 60%, 92% 25%, 96% 55%, 100% 30%, 100% 100%, 0 100%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={LOGO_URL}
              alt="Happy Tails by Aurora"
              className="w-14 h-14 rounded-full object-cover border-2 border-[#F4E8C8]/30 bg-[#F4E8C8]"
            />
            <div className="leading-tight">
              <div className="font-display text-2xl font-bold">Happy Tails</div>
              <div className="font-script text-[#f0c4d4] -mt-1 text-xl">by Aurora</div>
            </div>
          </div>
          <p className="text-[#F4E8C8]/85 max-w-xs leading-relaxed">
            Loving care while you&rsquo;re away — walks, cuddles, and peace of mind in the {SOCIAL.area}.
          </p>
        </div>

        <div>
          <h4 className="font-display text-xl mb-4 text-[#F4E8C8]">Get in touch</h4>
          <ul className="space-y-3">
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#f0c4d4]" />
              <a href={`tel:${SOCIAL.phoneRaw}`} data-testid="footer-phone" className="hover:underline">
                {SOCIAL.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#f0c4d4]" />
              <a href={`mailto:${SOCIAL.email}`} data-testid="footer-email" className="hover:underline break-all">
                {SOCIAL.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-[#f0c4d4]" />
              <span>{SOCIAL.area}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl mb-4 text-[#F4E8C8]">Follow along</h4>
          <div className="flex gap-3 mb-6">
            <a
              href={SOCIAL.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="w-11 h-11 rounded-full grid place-items-center bg-[#F4E8C8]/10 hover:bg-[#F4E8C8] hover:text-[#3F2A56] transition-colors"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href={SOCIAL.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="w-11 h-11 rounded-full grid place-items-center bg-[#F4E8C8]/10 hover:bg-[#F4E8C8] hover:text-[#3F2A56] transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
          <Link
            to="/book"
            data-testid="footer-book-cta"
            className="inline-block rounded-full bg-[#F4E8C8] text-[#3F2A56] font-semibold px-6 py-3 hover:-translate-y-0.5 transition-transform"
          >
            Request a Booking
          </Link>
        </div>
      </div>
      <div className="border-t border-[#F4E8C8]/15">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-5 flex flex-wrap items-center justify-between text-sm text-[#F4E8C8]/70 gap-3">
          <span>© {new Date().getFullYear()} Happy Tails by Aurora · Locally owned & operated</span>
          <span className="flex items-center gap-1.5">
            Made with <Heart className="w-3.5 h-3.5 fill-[#f0c4d4] text-[#f0c4d4]" /> for pets
          </span>
        </div>
      </div>
    </footer>
  );
}
